import React from "react";
import { render } from "react-dom";
// import HomePage from "./components/HomePage";
import PriceEditor from "./components/product/PriceEditor";

// render(<HomePage />, document.getElementById("root"));
render(<PriceEditor />, document.getElementById("root"));
